import { OrderCardSkeleton } from './OrderCardSkeleton'

/** Shared by the list itself and by the Hub's boot screen, so the two can
 * never disagree about the list's geometry. */
export const LIST_CONTAINER_CLASSES =
  'flex w-full flex-col items-center justify-end gap-16 md:gap-20 px-16 pt-24 pb-80 md:pt-40 md:pb-120 lg:p-0 md:max-w-[522px] md:max-lg:mx-auto'

/**
 * Exact-layout placeholder for the orders list (RP-5936): two row skeletons in
 * the list's own container, so the swap to content causes no layout shift.
 *
 * The Customer Hub renders this during its boot screen — before the order list
 * itself can mount — so the shell bars and these rows appear in the same frame.
 */
export default function OrderListSkeleton({
  isReserved,
}: {
  /** Reserve the layout without painting it (the anti-flash window). */
  isReserved?: boolean
}) {
  return (
    <div
      className={`${LIST_CONTAINER_CLASSES}${isReserved ? ' invisible' : ''}`}
      aria-busy="true"
      data-testid="orders-list-skeleton"
    >
      <OrderCardSkeleton />
      <OrderCardSkeleton />
    </div>
  )
}
